<template>
  <!-- top bar navigation -->
  <div class="headerbar">
    <!-- LOGO -->
    <div class="headerbar-left">
      <router-link class="logo d-none d-lg-block" :to="'/'">
        <img alt="Logo" :src="`${$publicPath}assets/logo.png`" />
        <span></span>
      </router-link>
      <router-link class="logo d-lg-none" :to="'/'">
        <img alt="Logo" :src="`${$publicPath}assets/treelogo.png`" />
        <span></span>
      </router-link>
    </div>

    <nav class="navbar-custom">
      <ul class="list-inline float-right mb-0">
        <li class="list-inline-item dropdown notif">
          <a
            class="nav-link dropdown-toggle arrow-none"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <i class="fa fa-fw fa-question-circle"></i>
          </a>
          <div
            class="dropdown-menu dropdown-menu-right dropdown-arrow dropdown-arrow-success dropdown-lg"
          >
            <!-- item-->
            <div class="dropdown-item noti-title">
              <h5>
                <small>Help and Support</small>
              </h5>
            </div>

            <!-- item-->
            <span class="dropdown-item notify-item">
              <p class="notify-details ml-0"></p>
            </span>
          </div>
        </li>

        <li class="list-inline-item dropdown notif">
          <a
            class="nav-link dropdown-toggle nav-user"
            data-toggle="dropdown"
            href="#"
            role="button"
            aria-haspopup="false"
            aria-expanded="false"
          >
            <span class="d-block d-sm-none">
              <i class="fas fa-user"></i>
            </span>
            <span class="d-none d-sm-block font-weight-bold">
              <i class="fas fa-user"></i>
              {{ userDesc }} / {{ userName }}
            </span>
          </a>
          <div class="dropdown-menu dropdown-menu-right profile-dropdown">
            <!-- item-->
            <div class="dropdown-item noti-title">
              <h5 class="text-overflow">
                <small>{{ `Hello, ` + userName }}</small>
              </h5>
            </div>
            <a
              href="javascript:void(null);"
              class="dropdown-item notify-item"
              @click="logout"
            >
              <i class="fas fa-power-off"></i>
              <span>登出 Logout</span>
            </a>
          </div>
        </li>
      </ul>

      <ul class="list-inline menu-left mb-0">
        <li class="float-left d-block d-lg-none">
          <button class="button-menu-mobile open-left" @click="openLeft">
            <i class="fa fa-fw fa-bars"></i>
          </button>
        </li>
        <li class="float-left d-none d-lg-block">
          <span style="color:black">
            <strong>{{ title }}</strong>
          </span>
          <span style="color: red;">
            <small v-if="VUE_APP_NODE_ENV === `development`">
              [本機開發]
            </small>
            <small v-else-if="VUE_APP_NODE_ENV === `testing`">[測試環境]</small>
            <small v-else-if="VUE_APP_NODE_ENV === `staging`">[平測環境]</small>
          </span>
        </li>
        <li></li>
      </ul>
    </nav>
  </div>
  <!-- End Navigation -->
</template>

<script>
export default {
  name: "headerBar",
  data() {
    return {
      conditions: "",
      title: this.$conf.SystemDesc,
      VUE_APP_NODE_ENV: process.env.VUE_APP_NODE_ENV
    };
  },
  computed: {
    userName() {
      return this.$store.state.auth.EmpName;
    },
    userDesc() {
      return this.$store.state.auth.DivName;
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
    openLeft() {
      this.$emit("toggle-menu-collapse");
    },
    openNew() {
      var win = window.open(window.location.href);
      win.focus();
    }
  }
};
</script>

<style>
.emp {
  font-size: 16px;
}
</style>
